import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  label?: string;
  href?: string;
}
export function CTAButton({
  className = '',
  label = 'GET THE TENNIS READY PACK',
  href = '#offer'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-tr-orange px-9 py-4 text-sm font-bold uppercase tracking-[0.06em] text-white shadow-lifted transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#d16a20] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tr-orange focus-visible:ring-offset-2 md:text-base ${className}`} data-id="element-67" data-mp="2fyjwb1h3jabz">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-68" data-mp="3cnrm4lor05lp" />
    </a>;
}